// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"35951a20","455":"fd0a7dcb","977":"a919f627"}[chunkId] + ".chunk.js";
};